var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "#9BA3AC",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.967422 1.03258C0.674922 1.32508 0.674922 1.79758 0.967422 2.09008L3.87742 5.00008L0.967422 7.91008C0.674922 8.20258 0.674922 8.67508 0.967422 8.96758C1.25992 9.26008 1.73242 9.26008 2.02492 8.96758L5.46742 5.52508C5.75992 5.23258 5.75992 4.76008 5.46742 4.46758L2.02492 1.02508C1.73992 0.740077 1.25992 0.740078 0.967422 1.03258Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/rightArrowIcon.2f6ea5ec.svg";
export { ForwardRef as ReactComponent };